import {
  Button,
  Dropdown,
  Space,
  Typography,
  Statistic,
  Tooltip,
  Modal,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faColumns,
  faPhoneSlash,
  faGears,
  faMicrophone,
  faMicrophoneSlash,
  faVideo,
  faVideoSlash,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faBellExclamation,
  faScreencast,
  faTableLayout,
} from "@fortawesome/pro-solid-svg-icons";
import { useContext } from "react";
import moment from "moment";
import { RoomContext, participantLayout } from "../../RoomContext";
import useLocalTracks from "../../hooks/useLocalTracks";
import { DeviceSettings } from "../VideoDevices";
const { Countdown } = Statistic;

const Actions = () => {
  const {
    toggleDisplay,
    display,
    audioEnabled,
    setAudioEnabled,
    videoEnabled,
    setVideoEnabled,
    disconnectFromRoom,
  } = useContext(RoomContext);

  const { videoTrack, audioTrack } = useLocalTracks();

  const toggleVideo = () => {
    if (videoEnabled) {
      videoTrack.disable();
    } else {
      videoTrack.enable();
    }

    setVideoEnabled(!videoEnabled);
  };

  const toggleAudio = () => {
    if (audioEnabled) {
      audioTrack.disable();
    } else {
      audioTrack.enable();
    }
    setAudioEnabled(!audioEnabled);
  };

  const items = [
    {
      key: "1",
      label: "Sidebar",
      onClick: () => {
        toggleDisplay(participantLayout.sidebar);
      },
    },
    {
      key: "2",
      label: "Spotlight",
      onClick: () => {
        toggleDisplay(participantLayout.spotlight);
      },
    },
    {
      key: "3",
      label: "Tiled",
      onClick: () => {
        toggleDisplay(participantLayout.tiled);
      },
    },
  ];

  const AlertGuardian = () => {
    return Modal.confirm({
      title: "Alert Guardian",
      content: <>Alert the parent or guardian that you need help?</>,
      onOk: () => {
        console.log("Send alert");
      },
    });
  };

  return (
    <div className="footer">
      <div className="footer-left">
        <Space direction="vertical">
          <Typography.Text type="secondary" className="recording-text">
            <FontAwesomeIcon
              icon={faCircle}
              className="fa-beat-fade"
              style={{
                "--fa-beat-fade-opacity": "0.6",
                "--fa-beat-fade-scale": ".75",
              }}
            />{" "}
            Recording
          </Typography.Text>
          <Countdown value={moment().add(1, "hours")} format="HH:mm" />
        </Space>
      </div>
      <div className="footer-main">
        <Space>
          <Button type="text" onClick={() => toggleAudio()}>
            <FontAwesomeIcon
              icon={audioEnabled ? faMicrophone : faMicrophoneSlash}
            />
          </Button>
          <Button type="text" onClick={() => toggleVideo()}>
            <FontAwesomeIcon icon={videoEnabled ? faVideo : faVideoSlash} />
          </Button>
          <Button type="text">
            <FontAwesomeIcon icon={faScreencast} />
          </Button>

          <MenuSpacer />

          <Dropdown
            menu={{
              items,
            }}
            placement="bottom"
          >
            <Button type="text">
              <FontAwesomeIcon icon={faTableLayout} />
            </Button>
          </Dropdown>
          <DeviceSettings type="text" />

          <MenuSpacer />

          <Button
            type="primary"
            className="red"
            onClick={() => disconnectFromRoom()}
          >
            <FontAwesomeIcon icon={faPhoneSlash} />
          </Button>
        </Space>
      </div>
      <div className="footer-right">
        <Tooltip title="Alert Guardian" placement="left">
          <Button className="red" type="text" onClick={AlertGuardian}>
            <FontAwesomeIcon icon={faBellExclamation} />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

const MenuSpacer = () => {
  return (
    <div
      style={{
        width: "1px",
        height: "100%",
        margin: "0 20px",
        backgroundColor: "gray",
        display: "block",
      }}
    >
      &nbsp;
    </div>
  );
};

export default Actions;
